import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Logo } from "../components/Logo";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";

/** Sprint 16 — Troca obrigatória quando senha_temporaria=true. */
export default function TrocarSenha() {
  const nav = useNavigate();
  const { user, setUser } = useAuth();
  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user) { nav("/login"); return; }
    if (!user.senha_temporaria) {
      // Já trocou — redireciona conforme role
      nav(user.role === "cliente" ? "/cliente/home" : "/app/dashboard", { replace: true });
    }
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (novaSenha.length < 6) return toast.error("Nova senha precisa de pelo menos 6 caracteres");
    if (novaSenha !== confirmar) return toast.error("Confirmação não confere");
    setBusy(true);
    try {
      await api.post("/auth/trocar-senha", { senha_atual: senhaAtual, nova_senha: novaSenha });
      toast.success("Senha alterada com sucesso!");
      // Atualiza user no contexto
      const newUser = { ...user, senha_temporaria: false, cliente_herdado: false };
      setUser?.(newUser);
      localStorage.setItem("lab_user", JSON.stringify(newUser));
      nav(user.role === "cliente" ? "/cliente/home" : "/app/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Falha ao trocar senha");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-zinc-50 to-zinc-100 p-6">
      <Card className="w-full max-w-md p-8" data-testid="page-trocar-senha">
        <div className="flex flex-col items-center mb-6">
          <Logo size="md" />
          <div className="mt-4 p-3 rounded-full bg-amber-100">
            <Lock className="w-6 h-6 text-amber-600" />
          </div>
        </div>
        <h1 className="text-xl font-bold text-center mb-2">Troca obrigatória de senha</h1>
        <p className="text-sm text-zinc-500 text-center mb-6">
          Você está usando uma senha temporária. Por segurança, defina uma senha pessoal agora.
        </p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="atual">Senha atual (temporária)</Label>
            <Input id="atual" type="password" value={senhaAtual} onChange={(e) => setSenhaAtual(e.target.value)} required data-testid="senha-atual" />
          </div>
          <div>
            <Label htmlFor="nova">Nova senha (mínimo 6 caracteres)</Label>
            <Input id="nova" type="password" value={novaSenha} onChange={(e) => setNovaSenha(e.target.value)} required minLength={6} data-testid="nova-senha" />
          </div>
          <div>
            <Label htmlFor="conf">Confirmar nova senha</Label>
            <Input id="conf" type="password" value={confirmar} onChange={(e) => setConfirmar(e.target.value)} required data-testid="confirmar-senha" />
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-orange-600 hover:bg-orange-700 text-white" data-testid="submit-trocar">
            {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Lock className="w-4 h-4 mr-2" />}
            Trocar senha
          </Button>
        </form>
      </Card>
    </div>
  );
}
